import axios from 'axios';

import {
  sessionActiveAuthConversationState,
  HasActiveAuthConversationState,
} from './session-active-auth-conversation-state';
import { isLoggedInUser } from 'utils/isLoggedInUser';
import { clearAllStorage } from 'genesys/genesys.storage';
import { chatLogout } from 'genesys/genesys';

const { True: TRUE, False: FALSE } = HasActiveAuthConversationState;

const MY_CHATS_ENDPOINT = '';

const CHANNEL_REQUEST_CONFIGS = {
  hsbcnet: {
    tokenType: 'OPENAM',
  },
  dbbuk: {
    tokenType: 'SESSION_TOKEN',
  },
};

const getAxiosClient = (() => {
  let axiosClient;

  return () => {
    if (axiosClient) {
      return axiosClient;
    }

    const { channel, myChatStatus } =
      window.utag_data?.hsbc_chat_assistant_config ?? {};

    const normalizedChannelName = channel.toLowerCase();

    const { tokenType } = CHANNEL_REQUEST_CONFIGS[normalizedChannelName] ?? {};

    axiosClient = axios.create({
      baseURL: myChatStatus,
      withCredentials: true,
      headers: {
        Token_Type: tokenType,
        channel: normalizedChannelName,
      },
    });

    return axiosClient;
  };
})();

const fetchHasActiveAuth = async () => {
  const axiosClient = getAxiosClient();

  let remoteActiveChat = FALSE;

  try {
    const { status } = await axiosClient.get(MY_CHATS_ENDPOINT);

    if (status === 200) {
      remoteActiveChat = TRUE;
    }
  } catch {}

  clearAllStorage();

  sessionActiveAuthConversationState.save(remoteActiveChat);

  return remoteActiveChat;
};

const postHasActiveAuth = () => getAxiosClient().post(MY_CHATS_ENDPOINT);

const deleteHasActiveAuth = () => getAxiosClient().delete(MY_CHATS_ENDPOINT);

export const getHasActiveAuthConversation = async () => {
  const localHasActiveAuth = sessionActiveAuthConversationState.get();

  if (localHasActiveAuth !== null) {
    return localHasActiveAuth === TRUE;
  }

  return (await fetchHasActiveAuth()) === TRUE;
};

export const saveHasActiveAuthConversation = async () => {
  try {
    await postHasActiveAuth();
  } finally {
    sessionActiveAuthConversationState.save(TRUE);
  }
};

export const deleteHasActiveAuthConversation = async () => {
  if (!isLoggedInUser()) {
    return;
  }

  try {
    chatLogout(true);

    await deleteHasActiveAuth();
  } finally {
    sessionActiveAuthConversationState.remove();
  }
};
